var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{attrs:{"to":'merchant/' + _vm.merchant._id}},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom-start",value:({
    content: _vm.merchant.name ? _vm.merchant.name : null,
    classes: _vm.elepsize ? 'elepsize' : ''
    }),expression:"{\n    content: merchant.name ? merchant.name : null,\n    classes: elepsize ? 'elepsize' : ''\n    }",modifiers:{"bottom-start":true}}],ref:"title"},[_vm._v(_vm._s(_vm.merchant.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }